import axiosClient from 'api/config/axiosClient';

const getListPartner = ({
  pageNumber,
  pageSize,
  keyword,
  sortField,
  sortDirection,
  productId,
  partnerName,
  domainName,
  isAutoApprove,
  partnerType,
  solitonEmail,
}) => {
  const url = `v1/partner?pageNumber=${pageNumber}&pageSize=${pageSize}&keyword=${keyword}&sortField=${sortField}&sortDirection=${sortDirection}&productId=${productId}&partnerName=${partnerName}&domainName=${domainName}&isAutoApprove=${isAutoApprove}&partnerType=${partnerType}&solitonEmail=${solitonEmail}`;

  return axiosClient.get(url);
};

const getListProduct = ({ keyword, isNotify }) => {
  const url = `v1/partner/product?keyword=${encodeURIComponent(
    keyword,
  )}&isNotify=${isNotify}`;
  return axiosClient.get(url);
};

const getListPartnerAccount = ({ keyword }) => {
  const url = `v1/account/partners?keyword=${encodeURIComponent(keyword)}`;
  return axiosClient.get(url);
};

const deletePartner = (partnerId) => {
  const url = `v1/partner/${partnerId}`;
  return axiosClient.delete(url);
};

const getDetailPartner = ({ partnerId, signal }) => {
  const url = `v1/partner/${partnerId}`;
  return axiosClient.get(url, signal);
};

const createPartner = (payload) => {
  const url = 'v1/partner';
  return axiosClient.post(url, payload);
};

const updateDetailPartner = ({ partnerId, payload }) => {
  const url = `v1/partner/${partnerId}`;
  return axiosClient.put(url, payload);
};

const getPartnerPage = ({ partnerId }) => {
  const url = `v1/partner/page/${partnerId}`;
  return axiosClient.get(url);
};
const getDetailPartnerPage = ({ partnerId, noticeId, uuid }) => {
  const url = `/v1/partner/page/${partnerId}/notice/${noticeId}`;
  return axiosClient.get(url);
};

const updatePartnerPage = ({ partnerId, payload }) => {
  const url = `v1/partner/page/${partnerId}`;
  return axiosClient.put(url, payload);
};

const downloadCSV = (payload) => {
  const url = `/v1/partner/csv`;
  return axiosClient.post(url, payload);
};

export {
  getListPartner,
  getListPartnerAccount,
  deletePartner,
  // deleteMultiPartner,
  createPartner,
  getListProduct,
  getDetailPartner,
  updateDetailPartner,
  getPartnerPage,
  updatePartnerPage,
  getDetailPartnerPage,
  downloadCSV,
};
